<template>
    <b-modal
        id="add-managers-modal"
        class="modal-demo"
        title-class="text-light"
        header-bg-variant="dark"
        header-text-variant="light"
        title-tag="h4"
        size="lg"
        @show="openModal"
        @hide="hideModal"
    >
        <template slot="modal-title">
            <span>Add manager to forum</span>
        </template>

        <div class="order-modal">
            <managers-table
                :forum-id="forumId"
                @selected-items="onSelectedItems"
            />
        </div>

        <template #modal-footer>
            <div class="col-12 d-flex justify-content-end">
                <button
                    type="submit"
                    class="btn btn-success waves-effect waves-light"
                    @click="addManagers"
                >
                    Assign Managers
                </button>
            </div>
        </template>
    </b-modal>
</template>

<script>
import { mapActions } from 'vuex';
import ManagersTable from '@/components/forums/ManagersTable';

export default {
    components: {
        ManagersTable
    },

    props: {
        forumId: {
            type: String,
            required: false,
            default: ''
        }
    },

    data() {
        return { selectedManagerIds: [] };
    },

    methods: {
        ...mapActions({
            assignManagersToForum: 'forums/assignManagersToForum'
        }),

        hideModal() {
            this.$bvModal.hide('add-managers-modal');
        },

        async addManagers() {
            await this.assignManagersToForum({
                managerIds: this.selectedManagerIds,
                id: this.forumId
            });

            this.hideModal();

            this.$emit('managers-assigned');
        },

        onSelectedItems(items) {
            this.selectedManagerIds = items;
        }
    }
};
</script>
